import React from 'react';
import './IntroVideo.scss';

const IntroVideo = () => {
  return <div className="intro-video-container" />;
};

export default IntroVideo;
